import React from "react";
import Logo from "./logo";
import Menu from "./menu";
import Buttons from "./buttons";
import Mobile_menu from "./mobile-menu";
import { useState, useEffect } from "react";
function Header() {
  // const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //     const onPageLoad = () => {
  //         setLoading(true);
  //     };

  //     // Check if the page has already loaded
  //     if (document.readyState === 'complete') {
  //         onPageLoad();
  //         setLoading(false);
  //     } else {
  //         window.addEventListener('load', onPageLoad);
  //         // Remove the event listener when component unmounts
  //         return () => window.removeEventListener('load', setLoading(false));
  //     }
  // }, []);;
  return (
    <>
      {/* <div className={loading ? 'active loading' : 'loading'}>
                <img src={process.env.PUBLIC_URL + '/images/loading.svg'} className="img-fluid" />
            </div> */}
      <header className="mainHeader">
        <div className="mx-4">
          <div className="row">
            <Mobile_menu />
            <Logo />
            <Menu />
            <Buttons />
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
